<template>
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-dashboard-menu></coach-dashboard-menu>

    <!-- Page Content -->
    <div class="content court-bg">
        <div class="container">

            <!-- Sort By -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="sortby-section court-sortby-section">
                        <div class="sorting-info">
                            <div class="row d-flex align-items-center">
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                                    <div class="coach-court-list">
                                        <all-court-tabset></all-court-tabset>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                                    <div class="sortby-filter-group court-sortby">
                                        <div class="sortbyset week-bg">
                                            <div class="sorting-select">
                                                <vue-select :options="Week" id="weekthis" placeholder="This Week" />
                                            </div>
                                        </div>
                                        <div class="sortbyset">
                                            <span class="sortbytitle">Sort By</span>
                                            <div class="sorting-select">
                                                <vue-select :options="Sort" id="Pricethis" placeholder="Relevance" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- Sort By -->

            <div class="row">
                <div class="col-sm-12">
                    <div class="court-tab-content">
                        <div class="card card-tableset">
                            <div class="card-body">
                                <div class="coache-head-blk">
                                    <div class="row align-items-center">
                                        <div class="col-md-6">
                                            <div class="court-table-head">
                                                <h4>Courts</h4>
                                                <p>View all active courts</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div id="tablefilter">
                                                <div class="dataTables_filter">
                                                    <label> 
                                                        <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <a-table class="table datatable" :columns="columns" :data-source="data">
                                        <template #bodyCell="{ column, record }">
                                            <template v-if="column.key === 'Name'">
                                                <h2 class="table-avatar">
                                                    <a href="javascript:void(0);" class="avatar avatar-sm  flex-shrink-0"><img
                                                            class="avatar-img"
                                                            :src="require(`@/assets/img/booking/${record.Image}`)"
                                                            alt="User"></a>
                                                    <span class="table-head-name flex-grow-1">
                                                        <a href="javascript:void(0);">{{ record.Name }}</a>
                                                        <span>{{ record.Court }}</span>
                                                    </span>
                                                </h2>
                                            </template>
                                            <template v-else-if="column.key === 'Amount'">
                                                <div><span class="pay-dark">{{ record.Amount }}</span></div>
                                            </template>
                                            <template v-else-if="column.key === 'Details'">
                                                <div class="text-pink view-detail-pink"><a href="javascript:;"><i
                                                            class="feather-eye"></i>{{ record.Details }}</a></div>
                                            </template>
                                            <template v-else-if="column.key === 'Status'">
                                                <div class="table-inset-btn">
                                                    <div class="interset-btn">
                                                        <div class="status-toggle d-inline-flex align-items-center">
                                                            <input type="checkbox" :id="record.Check_id" class="check">
                                                            <label :for="record.Check_id"
                                                                class="checktoggle">{{ record.Status }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else-if="column.key === 'action'">
                                                <td class="text-end">
                                                    <div class="dropdown dropdown-action table-drop-action">
                                                        <a href="javascript:void(0);" class="action-icon dropdown-toggle"
                                                            data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                class="fas fa-ellipsis-h"></i></a>
                                                        <div class="dropdown-menu dropdown-menu-end">
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="feather-edit"></i>Edit</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="feather-trash"></i>Delete</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </template>
                                        </template>
                                    </a-table>
                                </div>
                            </div>
                        </div>
                        <div class="tab-footer">
                            <div class="row">
                                <div class="col-md-6">
                                    <div id="tablelength">
                                        <div class="dataTables_length" id="DataTables_Table_0_length">
                                            <label>Show
                                                <select class="custom-select custom-select-sm form-control form-control-sm">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="-1">All</option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div id="tablepage">
                                        <div class="dataTables_paginate paging_simple_numbers"
                                            id="DataTables_Table_0_paginate">
                                            <ul class="pagination">
                                                <li class="paginate_button page-item previous disabled"
                                                    id="DataTables_Table_0_previous"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                                                        class="page-link"><i class="feather-chevrons-left"></i></a></li>
                                                <li class="paginate_button page-item active"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0"
                                                        class="page-link">1</a></li>
                                                <li class="paginate_button page-item next disabled"
                                                    id="DataTables_Table_0_next"><a href="javascript:void(0);"
                                                        aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                                                        class="page-link"><i class="feather-chevrons-right"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
const data = [
    {
        "Image": "booking-03.jpg",
        "Name": "Feather Badminton",
        "Court": "Court 3",
        "Location": "Jackson, MS",
        "Amount": "$250",
        "Max_Guest": 1,
        "Additional": 2,
        "Added": "Fri, Jul 12",
        "Details": "View Details",
        "Status": "checkbox",
        "Check_id": "status_3"
    },
    {
        "Image": "booking-05.jpg",
        "Name": "Marsh Academy",
        "Court": "Court 1",
        "Location": "Victoria, TX",
        "Amount": "$120",
        "Max_Guest": 1,
        "Additional": 2,
        "Added": "Mon, Jul 12",
        "Details": "View Details",
        "Status": "checkbox",
        "Check_id": "status_5"
    },
    {
        "Image": "booking-02.jpg",
        "Name": "Wing Sports Academy",
        "Court": "Court 2",
        "Location": "South Bend, IN",
        "Amount": "$180",
        "Max_Guest": 1,
        "Additional": 2,
        "Added": "Wed, Jul 12",
        "Details": "View Details",
        "Status": "checkbox",
        "Check_id": "status_2"
    }
]

const columns = [
    {
        title: "Court Name",
        dataIndex: "Name",
        key: "Name",
        sorter: {
            compare: (a, b) => {
                a = a.Name.toLowerCase();
                b = b.Name.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Location",
        dataIndex: "Location",
        sorter: {
            compare: (a, b) => {
                a = a.Location.toLowerCase();
                b = b.Location.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Amount",
        dataIndex: "Amount",
        key: "Amount",
        sorter: {
            compare: (a, b) => {
                a = a.Amount.toLowerCase();
                b = b.Amount.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Max Guest",
        dataIndex: "Max_Guest",
        sorter: {
            compare: (a, b) => {
                a = a.Max_Guest.toLowerCase();
                b = b.Max_Guest.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Additional Guests",
        dataIndex: "Additional",
        sorter: {
            compare: (a, b) => {
                a = a.Additional.toLowerCase();
                b = b.Additional.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Added On",
        dataIndex: "Added",
        sorter: {
            compare: (a, b) => {
                a = a.Added.toLowerCase();
                b = b.Added.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Details",
        dataIndex: "Details",
        key: "Details",
        sorter: {
            compare: (a, b) => {
                a = a.Details.toLowerCase();
                b = b.Details.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "Status",
        dataIndex: "Status",
        key: "Status",
        sorter: {
            compare: (a, b) => {
                a = a.Status.toLowerCase();
                b = b.Status.toLowerCase();
                return a > b ? -1 : b > a ? 1 : 0;
            },
        },
    },
    {
        title: "",
        key: "action",
        sorter: true,
    },
]

export default {
    data() {
        return {
            title: "Courts",
            text: "Home",
            text1: "Courts",
            columns,
            data,
            Sort: ["Relevance", "Price"],
            Week: ["This Week", "One Day"]
        }
    },
}
</script>